import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CardCbioComponent } from './cardCbio/card-cbio.component';
import { environment } from '../environments/environment';
@Component({
  standalone: true,
  selector: 'pvd-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule, TranslateModule, CardCbioComponent]
})
export class AppComponent {
  title = 'pvd-cbio-portal';
  lang;
  // Construtor veficar a lingua padrão do browser
  // Se ela for diferente de pt/en, padrão é pt
  constructor(public translate: TranslateService) {
    translate.addLangs(['pt', 'en']);
    translate.setDefaultLang('pt');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|pt/) ? browserLang : 'pt');

  }


  // Método para mudança de lingua
  public languageChange(lang): void {
    this.lang = lang;
    this.translate.use(lang);
  }
}
